module.exports = __webpack_public_path__ + "static/media/month.c7e0222e.png";